module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHklEQVQImWOUEFH9f+lAK8ONjfsZmBiQAILDwMAAALamBbXFX3dIAAAAAElFTkSuQmCC"